import { persistor } from './index';

export default function ConditionalPersist(): void {
  const url = localStorage.getItem('url');
  if (url !== window.location.href) {
    persistor.purge();
  }
}
